import React from 'react';
import { getUserName } from '../utils/user';
import TooltipHeader from 'refactored/features/emergencies/ui/texts/tooltip-header';
import TooltipBody from 'refactored/features/emergencies/ui/texts/tooltip-body';
import { withTranslation } from 'react-i18next';

const AgentAssignedTooltip = ({ ticket, t }) => {
  const id = ticket?.assigned_to?.id;
  const user = ticket?.assigned_to || {};
  const head = id ? t('assigned_to') : t('no_agent');
  const body = id ? getUserName(user) : '';
  return (
    <>
      <TooltipHeader>{head}</TooltipHeader>
      <TooltipBody>{body}</TooltipBody>
    </>
  );
};

export default withTranslation('Emergencies')(AgentAssignedTooltip);
